class RolesController {
  constructor(RolesFactory, $rootScope, $state, $filter, ngDialog) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");

    vm.rootScope = $rootScope;

    vm.$onInit = () => {
      vm.showRoleForm = false;
      vm.permissions = [];
      vm.rolePermissions = [];
      RolesFactory.getAllPermissions().then((response) => {
        vm.permissions = response.map((p) => ({
          id: p.id,
          description: p.description,
          display_name: $translate(p.name),
        }));
      });
      reloadData();
    };

    vm.gridOptions = {
      paginationPageSizes: [50, 100, 150],
      paginationPageSize: 50,
      enableSorting: true,
      enableColumnMenus: false,
      enableFiltering: true,
      columnDefs: [
        {
          field: "display_name",
          enableFiltering: true,
          name: $translate("DISPLAY_NAME"),
        },
        {
          field: "description",
          enableFiltering: true,
          name: $translate("DESCRIPTION"),
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<button class="btn btn-sm btn-warning" translate ' +
            'ng-click="grid.appScope.vm.openForm(row.entity)">EDIT</button> ' +
            "</div>" +
            "</div>",
          width: "140",
        },
      ],
    };

    vm.submit = () => {
      vm.role.permissions = vm.rolePermissions;
      if (vm.role.id) {
        RolesFactory.update(vm.role.id, vm.role).then((response) => {
          ngDialog.open({ template: "successTemplate" });
          reloadData();
          vm.role = response.data;
        });
      } else {
        RolesFactory.create(vm.role).then((response) => {
          ngDialog.open({ template: "successTemplate" });
          reloadData();
          vm.role = response.data;
        });
      }
    };

    vm.openForm = (role) => {
      vm.role = {};
      vm.rolePermissions = [];
      if (role) {
        angular.copy(role, vm.role);
        Object.entries(vm.role.perms).forEach(([key, value]) => {
          vm.rolePermissions[value.id] = true;
        });
      }
      vm.showRoleForm = true;
    };

    vm.closeForm = () => {
      vm.showRoleForm = false;
    };

    function reloadData() {
      RolesFactory.getAll().then((response) => {
        vm.gridOptions.data = response.data;
      });
    }
  }
}

export default RolesController;



// WEBPACK FOOTER //
// ./client/app/components/roles/roles.controller.js